export default __webpack_public_path__ + "static/media/chrono-zero-icon.568464d3.svg";